const map = {
	"./blockchain-technology-to-ensure-transparency-security-reliability.png": 70854,
	"./dynamic-workflow-automation.png": 39634,
	"./payroll-made-easier-with-smartpeople.png": 4602,
	"./people-management-made-easier-with-SmartPeople.png": 44074
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5091;